export const LikeIcon = () => {
  return (
    <svg
      width='18'
      height='15'
      viewBox='0 0 18 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.018 0.0314703C11.932 0.205562 12.5262 1.05258 12.3434 1.92304L12.2625 2.3047C12.0762 3.1986 11.7316 4.04897 11.25 4.82234H16.3125C17.2441 4.82234 18 5.54214 18 6.42934C18 7.0487 17.6309 7.58772 17.0895 7.85555C17.4727 8.15017 17.7188 8.60213 17.7188 9.10767C17.7188 9.89108 17.1281 10.5439 16.3512 10.6845C16.5059 10.9289 16.5938 11.2135 16.5938 11.5182C16.5938 12.2313 16.1051 12.8372 15.4301 13.0448C15.4547 13.1553 15.4688 13.2725 15.4688 13.393C15.4688 14.2802 14.7129 15 13.7812 15H10.3535C9.68555 15 9.03516 14.8125 8.47969 14.461L7.12617 13.6006C6.1875 13.0046 5.625 12.0003 5.625 10.9256V7.20271C5.625 6.22511 6.09258 5.30444 6.89062 4.69177L7.15078 4.49424C8.08242 3.78448 8.71875 2.7868 8.95078 1.6753L9.03164 1.29363C9.21445 0.423176 10.1039 -0.142621 11.018 0.0314703ZM1.125 5.358H3.375C3.99727 5.358 4.5 5.83676 4.5 6.42934V13.9287C4.5 14.5212 3.99727 15 3.375 15H1.125C0.502734 15 0 14.5212 0 13.9287V6.42934C0 5.83676 0.502734 5.358 1.125 5.358Z'
        fill='#6DBC7B'
      />
    </svg>
  );
};
